import React from 'react';
import { map, join } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getClassNameGenerator } from 'helper/className';
import { withTranslate } from '../../decorators/withTranslate';

const UserInfo = ({ className, account, t }) => (
  <div className={classNames(className, UserInfo.className)}>
    <div className={UserInfo.getClassName('name')}>
      <span display-if={account.isActAs}>{t('Acting as ')}</span>
      <span>{account.displayName}</span>
    </div>
    <div className={UserInfo.getClassName('roles')}>
      {UserInfo.getRoles(account)}
    </div>
  </div>
);

UserInfo.className = 'user-info';
UserInfo.getClassName = getClassNameGenerator(UserInfo.className);

UserInfo.getRoles = (account) => join(map(account.roles, (role) => role.name), ', ');

UserInfo.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  account: PropTypes.object,
  t: PropTypes.func
};

UserInfo.defaultProps = {
  account: {}
};

export default withTranslate()(UserInfo);
